// Combined Dealers + Franchise apply form (legacy site had both; we unify under tabs)
import React, { useState } from "react";
import { postFranchise } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import { ArrowRight, Check } from "lucide-react";

const Apply = ({ kind }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", city: "", state: "", message: "" });
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    try {
      await postFranchise({ ...form, type: kind });
      setSent(true);
      setForm({ name: "", email: "", phone: "", company: "", city: "", state: "", message: "" });
    } catch {
      setErr("Submission failed. Please try again.");
    }
  };

  const isDealer = kind === "dealer";
  return (
    <>
      <PageHero
        eyebrow={isDealer ? "Dealer Network" : "Franchise Programme"}
        title={isDealer ? "Become a Jhalani Tools dealer" : "Apply for a Jhalani franchise"}
        intro={isDealer
          ? "Join our growing pan-India dealer network. Best-in-class margins, exclusive territories, full marketing support."
          : "Run a Jhalani Tools franchise outlet in your city. Turnkey setup, training, and ongoing operational support."}
        breadcrumbs={<>Home / <span className="text-white">{isDealer ? "Dealers" : "Franchise"}</span></>}
      />
      <Section>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="eyebrow">What we offer</div>
            <h2 className="mt-2 font-display font-black uppercase text-3xl tracking-tight leading-tight">{isDealer ? "Sell India's most trusted hand tools" : "Backed by a 10+ year brand"}</h2>
            <ul className="mt-6 space-y-3 text-sm">
              {(isDealer
                ? [
                    "Wholesale pricing with industry-best margins",
                    "Exclusive territory protection (subject to volume)",
                    "Free POS branding, banners and catalogues",
                    "Direct support from our regional sales team",
                    "Co-op marketing & lead-routing for B2B enquiries",
                  ]
                : [
                    "Turnkey store setup support — interior, branding, fitouts",
                    "Initial inventory at preferential rates",
                    "Staff training and operational SOPs",
                    "Lead generation via digital and trade-show marketing",
                    "Quarterly business reviews and growth planning",
                  ]
              ).map((b) => (
                <li key={b} className="flex items-start gap-2"><Check className="w-4 h-4 mt-0.5 text-[var(--jt-primary)] flex-shrink-0" /><span>{b}</span></li>
              ))}
            </ul>
          </div>

          <form onSubmit={onSubmit} className="lg:col-span-7 bg-[var(--jt-ink)] text-white p-8 lg:p-10" data-testid={`${kind}-form`}>
            <div className="eyebrow">Application</div>
            <h2 className="mt-2 font-display font-black uppercase text-3xl tracking-tight">Apply now</h2>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input required placeholder="Your name *" data-testid={`${kind}-name`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input required type="email" placeholder="Email *" data-testid={`${kind}-email`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input required placeholder="Phone *" data-testid={`${kind}-phone`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <input placeholder="Company / Firm name" data-testid={`${kind}-company`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
              <input placeholder="City" data-testid={`${kind}-city`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
              <input placeholder="State" data-testid={`${kind}-state`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)]" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} />
              <textarea rows={4} placeholder="Tell us about your business, target market, capacity..." data-testid={`${kind}-message`} className="bg-white/5 border border-white/15 px-3 py-3 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)] sm:col-span-2" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
            <button type="submit" data-testid={`${kind}-submit`} className="mt-6 jt-btn jt-btn-primary">
              {sent ? <>Submitted <Check className="w-4 h-4" /></> : <>Submit Application <ArrowRight className="w-4 h-4" /></>}
            </button>
            {err && <div className="mt-3 font-mono text-xs text-red-400">{err}</div>}
            {sent && <div className="mt-3 font-mono text-xs text-[var(--jt-primary)]" data-testid={`${kind}-success`}>Application received. Our team will reach out within 2 business days.</div>}
          </form>
        </div>
      </Section>
    </>
  );
};

export const Dealers = () => <Apply kind="dealer" />;
export const Franchise = () => <Apply kind="franchise" />;
